// eslint-disable-next-line no-extend-native
String.prototype.toTitleCase = function () {
    return this.toString().toLowerCase().replace(/(^|\s)\S/g, function (t) { return t.toUpperCase() });
}
